import { render, staticRenderFns } from "./AmostrasInfoOutros.vue?vue&type=template&id=6946ad20&"
import script from "./AmostrasInfoOutros.vue?vue&type=script&lang=ts&"
export * from "./AmostrasInfoOutros.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports